import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import EnquiryForm from "./EnquiryForm";
import { Reveal } from "./Reveal";
import { SITE } from "../data/site";
import { WhatsAppIcon } from "./Header";

export const CTASection = ({ title = "Talk to a YEIDA Plot Specialist", source, testid = "cta-section" }) => (
    <section className="bg-navy grain-overlay py-16 lg:py-24" data-testid={testid}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
            <Reveal>
                <p className="text-xs uppercase tracking-[0.3em] font-mono font-semibold text-gold mb-4">Quick Enquiry</p>
                <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight leading-tight">
                    {title}
                </h2>
                <p className="mt-4 text-slate-300 text-base sm:text-lg leading-relaxed max-w-md">
                    Share your requirement and get a callback within 15 minutes with verified, currently available plots.
                </p>
                <div className="mt-8 flex flex-wrap gap-3">
                    <a
                        href={SITE.phoneHref}
                        data-testid={`${testid}-call-button`}
                        className="inline-flex items-center gap-2 border border-gold/50 text-gold font-semibold text-sm px-5 py-3 rounded-sm hover:bg-gold hover:text-navy transition-colors"
                    >
                        <Phone className="w-4 h-4" /> Call for Available Plots
                    </a>
                    <a
                        href={SITE.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`${testid}-whatsapp-button`}
                        className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-5 py-3 rounded-sm hover:brightness-95 transition-all"
                    >
                        <WhatsAppIcon className="w-4 h-4" /> WhatsApp Us
                    </a>
                </div>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="bg-white rounded-lg p-6 sm:p-8 shadow-2xl border-t-4 border-gold">
                    <h3 className="font-serif text-navy text-xl font-bold mb-5">Get Verified Plot Options</h3>
                    <EnquiryForm source={source || title} testid={`${testid}-form`} compact />
                </div>
            </Reveal>
        </div>
    </section>
);

export const RelatedLinks = ({ links, title = "Related Resources" }) => (
    <section className="py-14 bg-white border-t border-slate-100" data-testid="related-links">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <h2 className="text-xs uppercase tracking-[0.3em] font-mono font-semibold text-gold-deep mb-6">{title}</h2>
            <div className="flex flex-wrap gap-3">
                {links.map((l) => (
                    <Link
                        key={l.to + l.label}
                        to={l.to}
                        data-testid={`related-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="group inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 text-sm font-medium text-slate-700 hover:border-gold hover:text-navy hover:bg-gold-soft/40 transition-all"
                    >
                        {l.label}
                        <ArrowRight className="w-3.5 h-3.5 text-gold-deep group-hover:translate-x-0.5 transition-transform" />
                    </Link>
                ))}
            </div>
        </div>
    </section>
);
